var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set-page"},[_c('div',{staticClass:"layout-title"},[_c('i',{staticClass:"iconfont icon-shouye"}),_c('span',{staticClass:"route-name"},[_vm._v(_vm._s(_vm.routeInfo.title))])]),_c('div',{staticClass:"set-con"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }